import React, { useState } from "react";
import { Button } from "react-bootstrap";
import PricingFoundationList from "./PricingFoundationList";
import CustomerSkuPricingList from "./CustomerSkuPricingList";

const PricingFoundation = () => {
  const [activeView, setActiveView] = useState("all");

  return (
    <div className="container-fluid py-2">
      <div className="d-flex gap-2 mb-3">
        <Button
          size="sm"
          variant={activeView === "all" ? "primary" : "outline-primary"}
          onClick={() => setActiveView("all")}
        >
          All Pricing
        </Button>
        <Button
          size="sm"
          variant={activeView === "byCustomer" ? "primary" : "outline-primary"}
          onClick={() => setActiveView("byCustomer")}
        >
          Supplier SKU Pricing
        </Button>
      </div>
      {activeView === "all" ? <PricingFoundationList /> : <CustomerSkuPricingList />}
    </div>
  );
};

export default PricingFoundation;